export default function formatDateString(date) {
  if (!date) {
    return '';
  }
  const dateObj = new Date(date);
  // eslint-disable-next-line no-restricted-globals
  return (dateObj instanceof Date && !isNaN(dateObj))
    ? `${(dateObj.getMonth() + 1)}/${dateObj.getDate()}/${dateObj.getFullYear()}` : '';
}
